import { isDev } from "constants/env-variables";
import { formatPrice } from "@stadium/helpers/currency";

import imagine from "@stadium/shared/src/assets/images/companies/imagine-pediatrics.svg";
import premier from "@stadium/shared/src/assets/images/companies/premier.svg";
import amazon from "@stadium/shared/src/assets/images/companies/amazon.svg";
import unitedHealthcare from "@stadium/shared/src/assets/images/companies/united-healthcare.svg";
import microsoft from "@stadium/shared/src/assets/images/companies/microsoft.svg";
import figma from "@stadium/shared/src/assets/images/companies/figma.svg";
import westernUnion from "@stadium/shared/src/assets/images/companies/western-union.svg";
import isolved from "@stadium/shared/src/assets/images/companies/isolved.svg";
import fidelity from "@stadium/shared/src/assets/images/companies/fidelity.svg";
import apollo from "@stadium/shared/src/assets/images/companies/apollo.svg";

import g2 from "@stadium/shared/src/assets/images/reviews/icon-g2.svg";
import google from "@stadium/shared/src/assets/images/reviews/icon-google.svg";
import arrow from "@stadium/shared/src/assets/images/reviews/icon-arrow.svg";

import localFulfillment from "@stadium/shared/src/assets/images/why-stadium/local-fulfillment.svg";
import scalable from "@stadium/shared/src/assets/images/why-stadium/scalable.svg";
import robustCatalog from "@stadium/shared/src/assets/images/why-stadium/robust-catalog.svg";

import casePremierRoofing from "@stadium/shared/src/assets/images/case-studies/premier-roofing.svg";
import caseApollo from "@stadium/shared/src/assets/images/case-studies/apollo.svg";
import caseFidelity from "@stadium/shared/src/assets/images/case-studies/fidelity.svg";

const defaultFormField = { value: "", validates: { presence: true } };

const optionalFormField = { value: "", validates: { presence: false } };

export const DEFAULT_ARR = [];
export const DEFAULT_OBJ = {};

export const TEAM_ROLE_OPTIONS = [
  { title: "HR" },
  { title: "Events" },
  { title: "Marketing/Brand" },
  { title: "Sales" },
  { title: "Customer Service" },
  { title: "Operations" },
  { title: "C-Suite" },
  { title: "Executive Assistant" },
];

export const STADIUM_USAGE_OPTIONS = [
  { title: "Just the one time" },
  { title: "Ongoing for my entire company" },
  { title: "Ongoing for select team(s)" },
];

const PEER_TO_PEER = {
  key: "1",
  title: "Kudos Program",
  subTitle: "(employee-to-employee)",
};

export const SWAG_OPTIONS = [
  { key: "1", title: "Shops" },
  { key: "2", title: "Bulk" },
  { key: "3", title: "On-Demand" },
  { key: "4", title: "Storage" },
  { key: "5", title: "Kits" },
  { key: "6", title: "In-Person Events" },
];

export const GIFTING_OPTIONS = [
  { key: "1", title: "Snack Boxes" },
  { key: "2", title: "Employee Gifting", subTitle: "(Holiday, birthday)" },
  { key: "3", title: "Prospect/Client Gifting" },
];

const getRecognitionOptions = () => [
  PEER_TO_PEER,
  {
    key: "2",
    title: "Milestone Recognitions",
    subTitle: "(years of service, new hire)",
  },
  { key: "3", title: "Incentives", subTitle: "(Sales, workplace safety, wellness programs)" },
];

export const getCustomizeYourDemoOfferings = () => {
  const offerings = [
    { key: "recognition", title: "Recognition", options: getRecognitionOptions() },
    { key: "swag", title: "Swag", options: SWAG_OPTIONS },
    { key: "gifting", title: "Gifting", options: GIFTING_OPTIONS },
    { key: "other", title: "Other", options: [] },
  ];

  return offerings;
};

export const DEMO_OFFERING_LABEL_COUNT = 1;

export const TEAM_INPUT = {
  fieldName: "role",
  options: TEAM_ROLE_OPTIONS,
  placeholderText: "Select role",
  otherInput: { label: "Other", placeHolderText: "Please specify" },
};

const DEFAULT_STADIUM_USAGE = {
  fieldName: "stadiumUsage",
  placeholderText: "Select usage",
};

export const STADIUM_USAGE = {
  ...DEFAULT_STADIUM_USAGE,
  options: STADIUM_USAGE_OPTIONS,
};

export const COMPANY_SIZE_OPTIONS = [
  { title: "Small (Fewer than 100 employees)" },
  { title: "Medium (101 - 500 employees)" },
  { title: "Large (501 - 2,000 employees)" },
  { title: "Enterprise (2,000+ employees)" },
];

export const COMPANY_INPUT = {
  fieldName: "companySize",
  options: COMPANY_SIZE_OPTIONS,
  placeholderText: "Select",
};

export const OTHER_INPUT_FIELDS_KEY = ["role", "currentSetup", "offerings"];

export const FORM_FIELDS_KEYS = {
  fullName: "fullName",
  email: "email",
  companyName: "companyName",
  role: "role",
  companySize: "companySize",
  offerings: "offerings",
  additionalinfo: "additionalinfo",
  phone: "phone",
  subscribeMarketingEmail: "subscribeMarketingEmail",
  stadiumUsage: "stadiumUsage",
};

export const OTHER = "Other";
export const OTHER_KEY = "other";

export const DEFAULT_FORM_VALUES = {
  fullName: { ...defaultFormField },
  email: {
    ...defaultFormField,
    validates: { ...defaultFormField.validates, email: true },
  },
  companyName: { ...defaultFormField },
  role: { ...defaultFormField, other: false },
  companySize: { ...defaultFormField },
  stadiumUsage: { ...defaultFormField, other: false },
  offerings: { ...defaultFormField, value: [], other: false },
  additionalinfo: { ...defaultFormField, validates: {} },
  phone: { ...defaultFormField },
  subscribeMarketingEmail: { ...optionalFormField, value: false },
};

export const QUERY_ORIGIN = "book_a_call";

export const EMAIL_WARNING = {
  heading: "That looks like a personal email",
  description:
    "That’s ok! However, we highly recommend using your company email for a more customized experience.",
};

export const BOOK_A_CALL_FORM_SUBMITTED = "book-a-call-form-submitted";

export const CALL_BOOKED = "call-booked";

export const STADIUM_BOOK_A_CALL_TREAT_TYPE = "Stadium";

export const RESTRICT_CHILIPIPER_KEYS = ["identifier", "program_id", "origin"];

export const BOOK_A_CALL_HUBSPOT_FORM_MAPPING = {
  first_name: "firstname",
  last_name: "lastname",
  email: "email",
  role: "jobtitle",
  country: "country",
  additionalinfo: "additionalinfo",
  company_size: "company_size",
  phone: "phone",
  offerings: "offerings",
  treat_type: "treat_type",
  stadium_usage: "stadium_usage",
};

export const BOOK_A_CALL_PAGE_NAME = "Book a Call";

export const STADIUM_BOOK_A_CALL_HUBSPOT_FORM_ID = !isDev()
  ? "8838e29c-c51f-4464-9e0d-58f51af9edf5"
  : "054c9cfb-306d-4dbb-8622-2637faf7f627";

export const getLowBudgetWarning = ({ lowestPackagePrice }) => ({
  heading: `Our packages start at $${formatPrice(lowestPackagePrice)} per year. `,
  description: `For budgets under $${formatPrice(
    lowestPackagePrice,
  )}, we recommend our self-serve options.`,
  ctaText: "GET STARTED FOR FREE",
});

export const ADVERTISING_BULLET_POINTS_SECTION = [
  { id: 1, title: "Gift to 170+ countries with hassle-free local fulfillment." },
  { id: 2, title: "Use us for your end-to-end swag needs." },
  { id: 3, title: "Automate gifting and leverage integrations." },
];

export const TRUSTED_BY_COMPANIES_LOGOS = [
  {
    id: 1,
    src: imagine,
    name: "Imagine",
  },
  {
    id: 2,
    src: premier,
    name: "Premier",
  },
  {
    id: 3,
    src: amazon,
    name: "Amazon",
  },
  {
    id: 4,
    src: unitedHealthcare,
    name: "United Healthcare",
  },
  {
    id: 5,
    src: microsoft,
    name: "Microsoft",
  },
  {
    id: 6,
    src: figma,
    name: "Figma",
  },
  {
    id: 7,
    src: westernUnion,
    name: "Western Union",
  },
  {
    id: 8,
    src: isolved,
    name: "isolved",
  },
  {
    id: 9,
    src: fidelity,
    name: "Fidelity",
  },
  {
    id: 10,
    src: apollo,
    name: "Apollo",
  },
];

export const COMPANY_REVIEWS = [
  {
    id: 1,
    src: g2,
    reviews: "1,586+ Reviews",
  },
  {
    id: 2,
    src: google,
    reviews: "444+ Reviews",
  },
  {
    id: 3,
    src: arrow,
    reviews: "628+ Reviews",
  },
];

export const WHY_STADIUM_SECTION = [
  {
    id: "local-fulfillment",
    img: localFulfillment,
    title: "Local Fulfillment",
    subTitle: "We fulfill locally in 170+ countries, so everyone feels valued.",
  },
  {
    id: 2,
    img: scalable,
    title: "Scalable",
    subTitle: "We make gifting a breeze, whether you’re gifting to 1 or 1,000+.",
  },
  {
    id: 3,
    img: robustCatalog,
    title: "Robust Catalog",
    subTitle: "From snacks to gift cards to swag—we’ve got it all.",
  },
];

export const RESOURCES_SECTION_BTN_LINKS = [
  {
    title: "Pricing",
    href: "https://www.bystadium.com/go/pricing",
  },
  {
    title: "Stadium Deck",
    href: "https://app-na1.hubspotdocuments.com/documents/8084862/view/818991171?accessId=d8e3ea",
  },
  {
    title: "Our Sustainability Efforts",
    href: "https://www.bystadium.com/corporate-social-responsibility",
  },
];

export const RESOURCES_SECTION_VIDEO_URL = "https://www.youtube.com/watch?v=F3GzXqfpET8";

export const CASE_STUDIES_CARDS = [
  {
    id: 1,
    image: casePremierRoofing,
    heading: "Construction",
    btnText: "Premier Roofing",
    url: "https://www.bystadium.com/case-overview/premier-roofing",
  },
  {
    id: 2,
    image: caseApollo,
    heading: "software development",
    btnText: "Apollo",
    url: "https://www.bystadium.com/case-overview/apollo",
  },
  {
    id: 3,
    image: caseFidelity,
    heading: "financial services",
    btnText: "Fidelity",
    url: "https://www.bystadium.com/case-study/financial-services",
  },
];

export const CASE_STUDIES_SEE_MORE_URL = "https://www.bystadium.com/case-studies";

export const CUSTOMER_EXPERIENCE_SECTION = [
  {
    id: 1,
    message:
      "Stadium is your all-inclusive resort, offering complete peace of mind with every detail handled from start to finish.",
    name: "Nicole K",
    designation: "Legal Specialist",
    organization: "wolters kluwer",
  },
  {
    id: 2,
    message:
      "If you're looking for a platform that has it all, Stadium’s a great option. With recognition, swag, gift cards, and experiences, it's a catch-all for everything.",
    name: "Megan C",
    designation: "Global Employee Experience Specialist",
    organization: "keyfactor",
  },
  {
    id: 3,
    message:
      "Stadium works well for very diverse and dispersed companies. If you want to do different campaigns, whether for recognition or boosting culture, Stadium is the best company.",
    name: "Shaira J",
    designation: "People Experience Manager",
    organization: "Apollo",
  },
];
